export default __webpack_public_path__ + "static/media/logo.761d7bb8.png";